export default class Client {
  public name: string = '';
  public phone: string = '';
  public photo: string | null = null;
  public uid: string | null = null;
}
